import moment from "moment";

/** Converte YYYY-MM-DD (ou Date) para ISO na meia-noite local do navegador. */
export function dateOnlyToLocalISO(value) {
  if (value == null || value === "") return null;

  const m =
    typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())
      ? moment(value.trim(), "YYYY-MM-DD")
      : moment(value);

  if (!m.isValid()) return null;
  return m.startOf("day").format();
}

/** Cópia do payload com campos de data em ISO local. */
export function withLocalDateISO(payload, fields = ["dueDate", "settledAt"]) {
  const result = { ...payload };
  for (const field of fields) {
    if (result[field] != null && result[field] !== "") {
      result[field] = dateOnlyToLocalISO(result[field]);
    } else if (result[field] === "") {
      result[field] = null;
    }
  }
  return result;
}
